/* c8 ignore start */
import { useEffect, useState } from "react";
import { useDeviceCheck } from "hooks";

export const useHandleAspectRatio = (props, useAspectRatio) => {
  const [aspectRatio, setAspectRatio] = useState(null);
  const { videoInfo, videoInfoMobile, videoInfo4k } = props;
  const { screenType } = useDeviceCheck();
  // Function to calculate the aspect ratio using width and height
  const calculateAspectRatio = () => {
    let mediaData;
    switch (screenType) {
      case "mobile":
        mediaData = videoInfoMobile?.id ? videoInfoMobile : videoInfo;
        break;
      case "web":
        mediaData = videoInfo;
        break;
      case "2k":
        mediaData = videoInfo;
        break;
      case "4k":
        mediaData = videoInfo4k?.id ? videoInfo4k : videoInfo;
        break;
      default:
        mediaData = videoInfo;
    }

    if (mediaData && mediaData.width && mediaData.height) {
      return mediaData.width / mediaData.height;
    } else {
      return null;
    }
  };
  useEffect(() => {
    if (!useAspectRatio) return;
    const ratio = calculateAspectRatio();
    setAspectRatio(ratio);
  }, [videoInfo, videoInfoMobile, videoInfo4k, screenType, useAspectRatio]); //eslint-disable-line
  const containerStyle = aspectRatio ? { aspectRatio: aspectRatio } : {};
  return { containerStyle, aspectRatio };
};
/* c8 ignore stop */
